import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";
import {RouterLink} from "@angular/router";
import {BootstrapIcon} from "../../directives/bootstrap-icon";
import {RouterLinkAppRoute} from "../../directives/router-link-app-route";

@Component({
  selector: "rf-home",
  templateUrl: "./home.html",
  styleUrl: "./home.scss",
  imports: [
    BootstrapIcon,
    NgOptimizedImage,
    RouterLink,
    RouterLinkAppRoute,
  ],
})
export class Home {
}
